import { render, staticRenderFns } from "./PersonView.vue?vue&type=template&id=34494cc0"
import script from "./PersonView.vue?vue&type=script&lang=js"
export * from "./PersonView.vue?vue&type=script&lang=js"
import style0 from "./PersonView.vue?vue&type=style&index=0&id=34494cc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports